export const statisticsConstants = {
	GetHomeStatistics: {
		FAILURE : 'GET_HOME_STATISTICS_FAILURE',
		REQUEST : 'GET_HOME_STATISTICS_REQUEST',
		SUCCESS : 'GET_HOME_STATISTICS_SUCCESS'
	},
	CLEAR: 'CLEAR_STATISTICS'
}